import { Loader2, RefreshCw } from "lucide-react";
import { useState } from "react";

import { applyUpdate, useIsUpdateAvailable } from "@/lib/app-update";

/**
 * « Nouvelle version disponible — Mettre à jour », dans le pied de page.
 *
 * Discret à dessein : une mise à jour n'a rien d'urgent, elle ne doit pas
 * occuper le haut de l'écran comme une coupure de connexion. Le conseil
 * d'enregistrer sa saisie est dans l'infobulle du bouton.
 */
export function UpdateNotice() {
  const available = useIsUpdateAvailable();
  const [updating, setUpdating] = useState(false);
  if (!available) return null;

  return (
    <span role="status" className="inline-flex items-center gap-2">
      <span className="hidden items-center gap-1 sm:inline-flex">
        <RefreshCw className="h-3.5 w-3.5" aria-hidden />
        Nouvelle version disponible
      </span>
      <button
        type="button"
        onClick={() => {
          setUpdating(true);
          void applyUpdate();
        }}
        disabled={updating}
        title="Enregistrez votre saisie en cours, puis mettez à jour."
        className="inline-flex h-6 items-center gap-1 border border-primary-foreground/70 px-2 text-[11px] font-semibold hover:bg-primary-foreground/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-foreground disabled:opacity-80"
      >
        {updating ? (
          <Loader2 className="h-3 w-3 animate-spin" aria-hidden />
        ) : (
          <RefreshCw className="h-3 w-3 sm:hidden" aria-hidden />
        )}
        {updating ? "Mise à jour…" : "Mettre à jour"}
      </button>
    </span>
  );
}
